import { getStoryOrTemplateById } from '../../../../routes/hasura';
import { useQuery } from '@tanstack/react-query';

export function useFetchStory({ storyId }: { storyId: string }) {
  return useQuery({
    queryKey: ['story', storyId],
    queryFn: () => getStoryOrTemplateById(false, storyId),
    enabled: !!storyId
  });
}
